import Icon,{ type IconName } from '../components/Icon'
import { mt,type MarketKey } from '../lib/i18n'
import type { BadgeId,BadgeView } from '../../shared/market/badges'

const ICON:Record<BadgeId,IconName>={first:'handshake',generous:'gift',trader:'swap',guide:'pin',trusted:'shield'}
const NAME:Record<BadgeId,MarketKey>={first:'badgeFirst',generous:'badgeGenerous',trader:'badgeTrader',guide:'badgeGuide',trusted:'badgeTrusted'}
const TEXT:Record<BadgeId,MarketKey>={first:'badgeFirstText',generous:'badgeGenerousText',trader:'badgeTraderText',guide:'badgeGuideText',trusted:'badgeTrustedText'}

/** The badges a neighbor has earned, with progress on the rest. Others see only the earned ones. */
export default function Badges({badges,own=false}:{badges:BadgeView[];own?:boolean}){
 const shown=own?badges:badges.filter(b=>b.earned)
 if(!shown.length)return null
 return <div className="badge-shelf"><ul>{shown.map(b=><li key={b.id} className={b.earned?'earned':'locked'} title={mt(TEXT[b.id])}><span className="badge-icon"><Icon name={ICON[b.id]} size={20}/></span><strong>{mt(NAME[b.id])}</strong><small>{b.earned?mt('badgeEarned'):`${b.have}/${b.need}`}</small></li>)}</ul></div>
}
